/* eslint-disable react/no-children-prop */
import { themeStore } from "@/stores/theme";
import { useTranslate } from "@/utils/lang";
import { AlbumWords } from "@/utils/lang/album";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Flex,
  Button,
  useBoolean,
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { albumStore } from "../store";
import { OpModalBaseProps } from "../type";

type Props = OpModalBaseProps & {
  albumId: number;
};

type OpData = { type: "rename"; data?: { id: number; name: string } };

function RenameModal(props: Props) {
  const { panelBg, boardBg } = themeStore.styles;
  const { isOpen, onClose, albumId, store = albumStore } = props;
  const [loading, setLoading] = useBoolean(false);
  const [opData, setOpData] = useState<OpData | null>();

  const { translate } = useTranslate();
  const content = {
    type: "rename",
    title: translate(AlbumWords.renameAlbumModalTitle),
    cancelBtn: translate(AlbumWords.cancel),
    confirmBtn: translate(AlbumWords.renameAlbumModalConfirm),
    loading: translate(AlbumWords.renameAlbumModalLoading),
    inputTitle: translate(AlbumWords.renameAlbumModalInputTitle),
    inputPlaceholder: translate(AlbumWords.renameAlbumModalPlaceholder),
  };

  const onSecondConfirm = () => {
    if (!opData || !opData.data) return;
    setLoading.on();
    if (opData?.type === "rename") {
      store.putAlbum(opData.data).then(onClose).finally(setLoading.off);
    }
  };

  const handleAlbumNameChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const name = e.target.value.slice(0, 20);
    setOpData({ type: "rename", data: { id: albumId, name } });
  };

  const albumData = store.albumList.find((album) => album.id === albumId);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent bg={panelBg} w="716px" mt="278px">
        <ModalHeader color="white" textAlign="center" pt="40px" fontSize="32px">
          {content.title}
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody px="88px">
          <Text color="white" mb="16px" fontSize="20px">
            {content.inputTitle.replace("$", albumData?.name ?? "")}
          </Text>
          <InputGroup color="#999999">
            <Input
              placeholder={translate(AlbumWords.renameAlbumModalPlaceholder)}
              maxLength={20}
              value={opData?.data?.name || ""}
              bg={boardBg}
              borderColor="#585858"
              onChange={handleAlbumNameChange}
            />
            <InputRightElement children={`${opData?.data?.name.length || 0}/20`} mr="8px" />
          </InputGroup>
          <Flex justify="center" mt="58px" mb="48px">
            <Button variant="dark.solid" w="140px" mr="14px" onClick={onClose}>
              {content.cancelBtn}
            </Button>
            <Button
              variant="primary"
              w="140px"
              disabled={!opData?.data?.name || loading}
              isLoading={loading}
              loadingText={content.loading}
              onClick={onSecondConfirm}
            >
              {content.confirmBtn}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
export default observer(RenameModal);
